module.exports = __webpack_public_path__ + "img/tools-training-material.5aa80d02.png";